import React, { useEffect, useState } from "react";

import styles from "./UpcomingEvents.module.css";
import client from "../../config/contentful.js";
import SimpleSlider from "../../Components/Slider/Slider.js";
import Page from "../../Components/Page/Page.js";

function UpcomingEventsPage() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    client
      .getEntries({
        content_type: "eventsPage",
      })
      .then((response) => {
        const allEvents = response.items[0].fields.events || [];

        // Get today's date (start of day)
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Filter for events happening today or later
        const upcoming = allEvents.filter((event) => {
          const eventDate = new Date(event.fields.datePicker);
          return !isNaN(eventDate) && eventDate >= today;
        });

        // Sort by ascending date (soonest first)
        upcoming.sort((a, b) => {
          const dateA = new Date(a.fields.datePicker);
          const dateB = new Date(b.fields.datePicker);
          return dateA - dateB;
        });

        setContent(upcoming);
      })
      .catch((error) => console.error(error));
  }, []);

  // Format like "9th November 2025"
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "long" });
    const year = date.getFullYear();

    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    return `${day}${suffix} ${month} ${year}`;
  };

  const parseSubtitle = (text) => {
    const parts = text.split(/(\[.*?\]\(.*?\))/g);
    return parts.map((part, index) => {
      const match = part.match(/\[(.*?)\]\((.*?)\)/);
      if (match) {
        return (
          <a
            key={index}
            href={match[2]}
            target="_blank"
            rel="noopener noreferrer"
          >
            {match[1]}
          </a>
        );
      }
      return part;
    });
  };

  const shortenUrl = (url, maxLength = 50) => {
    try {
      const { hostname, pathname } = new URL(url);
      let cleanUrl = `${hostname}${pathname}`;

      if (cleanUrl.length <= maxLength) return cleanUrl;

      // Truncate middle
      const half = Math.floor((maxLength - 3) / 2);
      return `${cleanUrl.slice(0, half)}…${cleanUrl.slice(-half)}`;
    } catch (err) {
      return url; // fallback if URL parsing fails
    }
  };

  return (
    <Page>
      <div className={styles.content}>
        <h1 className={styles.title}>Upcoming Events</h1>
        {content.length === 0 && (
          <p>No upcoming events at the moment. Please check back later!</p>
        )}
        {content.map((project, projectIndex) => (
          <div key={projectIndex}>
            <div className={styles.subtitle}>{project.fields.title}</div>
            <div className={styles.date}>
              {formatDate(project.fields.datePicker)}
            </div>
            {project.fields?.subtitle && (
              <div className={styles.tag}>
                {parseSubtitle(project.fields.subtitle)}
              </div>
            )}
            {project.fields?.outsideLink && (
              <div className={styles.link}>
                {project.fields?.linkTitle || "Find out more:"}{" "}
                <a
                  href={project.fields?.outsideLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {shortenUrl(project.fields?.outsideLink)}
                </a>
              </div>
            )}
            <div className={styles.imageContainer}>
              <SimpleSlider
                images={project.fields.images.map(
                  (asset) => `https:${asset.fields.file.url}`,
                )}
              />
            </div>
          </div>
        ))}
        <br />
        <div className={styles.subtitle}>
          Plus many more events planned for 2026!
        </div>
        <div className={styles.tag}>
          Please do get in touch if you have any suggestions! You can contact us
          at: <a href="wheatearstraw@gmail.com">wheatearstraw@gmail.com</a>
        </div>
        <br />
      </div>
    </Page>
  );
}

export default UpcomingEventsPage;
